export default {
  store_name: 'Nombre de la tienda',
  store_url: 'URL de la tienda',
  platform: 'Plataforma',
  seller_id: 'ID del vendedor',
  owner_name: 'Nombre del propietario de la tienda',
  store_owner_no: 'Número de documento del propietario',
  va_account: 'Cuenta Virtual (VA)',
  va_institute: 'Canal de Cuenta Virtual (VA)',
  va_status: 'Estado de la Cuenta Virtual (VA)',
  review_time: 'Hora de revisión',
  close_time: 'Hora de cierre',
  va_collection: 'Cobro por Cuenta Virtual (VA)',
  va_list: 'Lista de Cuentas Virtuales (VA)',
  bank_proof: 'Comprobante bancario',
  va_number: 'Cantidad de Cuentas Virtuales (VA)',
  va_transactions: 'Consulta de transacciones de Cuenta Virtual (VA)',
  generating: 'Generando...',
  download_excel: 'Descargar Excel',
  download_proof: 'Descargar archivo comprimido de certificados',
  transaction_status: 'Estado de la transacción',
  create_single_va_account: 'Crear una sola cuenta virtual',
  create_va_account: 'Crear cuenta virtual',
  single_create_va: 'Crear una sola VA',
  batch_create_va: 'Crear VA por lotes',
  account_details: 'Detalles de la cuenta',
  audit_status: 'Estado de revisión',
  total_number_va: 'Cantidad total de VA',
  enter_details_create_va: 'Ingrese los detalles de su cuenta para crear su cuenta virtual.',
  enter_details_create_a_va: ' Cree una cuenta virtual rellenando un formulario de creación',
  enter_details_create_batch_va: 'Cree cuentas virtuales por lotes subiendo un archivo Excel.',
  create_batch_virtual_accounts: 'Crear cuentas virtuales en lote',
  batch_virtual_accounts_details: 'Pasos para generar cuentas virtuales en lote',
  batch_virtual_accounts_tip_1: 'Descargue y complete la plantilla para crear cuentas virtuales en lote',
  va_template: 'Plantilla de VA',
  lastest_template_tips: 'Última plantilla: Lista de tiendas creadas actualizada',
  batch_virtual_accounts_tip_2: 'Utilice la plantilla de VA más reciente para subir su archivo completado y enviar las cuentas virtuales en lote',
  download_bank_proof_zip_tip: 'La descarga del archivo tomará algún tiempo. Por favor, no cambie a otras páginas del sistema durante el proceso. ¿Desea descargar ahora?'
}
